
export enum ProcessStepTypeEnum {
  Initial, Processing, Success, Failed
}
